<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item"><router-link to="/">{{ $t("home") }}</router-link></li>
        <li class="Breadcrumb__item"><router-link to="/faq-and-support">{{ $t("faqAndSupport") }}</router-link></li>
        <li class="Breadcrumb__item"><span>{{ $t("seasonDigipass") }}</span></li>
      </ul>
    </div>

    <div class="PageHeader">
      <h1 class="PageHeader__heading">{{ $t("faqAndSupport") }}</h1>
    </div>
    <div class="RichTextArea">
      <h2>{{ $t("seasonDigipass") }}</h2>
      <div v-html="$t('faqSeasonDigipass')"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqSeasonDigipass',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Faq/SeasonDigipass.vue